import type { Variant } from '../gameTypes.js';
import type { PianoChart } from '../pianoChart.js';
import { PALETTE_PRISM } from '../builtinPulseMaps/palettes.js';
import { buildBuiltinAudio } from '../builtinPulseMaps/audioFromOnsets.js';
import audioOnsets from '../circlesBuiltinMaps/audio/diamond.onsets.json' with { type: 'json' };
import { pianoVariantsFromSpec } from './pianoFromOnsets.js';

/**
 * The Return — NIVIRO (NCS). 64 BPM future bass — the slowest
 * tempo in the catalogue gives this chart the longest lookahead
 * windows of any track. Excellent reading practice.
 *
 * Synthesised from the Circles onset analysis. See the header doc
 * on {@link import('./01-on-and-on.js').ON_AND_ON_PIANO_VARIANTS}
 * for the curated-MIDI upgrade path.
 */
export const DIAMOND_PIANO_VARIANTS: Record<Variant, PianoChart> = pianoVariantsFromSpec({
  baseSlug: 'diamond',
  baseTitle: 'The Return',
  description:
    "NIVIRO's slow future-bass groove. Spacious 64 BPM phrasing — easy on the eyes, deliberate on the lanes.",
  difficulty: 3,
  totalBeats: 67,
  palette: PALETTE_PRISM,
  audio: buildBuiltinAudio({
    src: '/audio/circles/diamond.mp3',
    attribution: '"The Return" by NIVIRO [NCS Release] - https://ncs.io/TheReturn',
    data: audioOnsets,
  }),
  onsets: audioOnsets,
  sections: [
    {
      startBeat: 0,
      endBeat: 67,
      selectOpts: { kinds: ['lead', 'snare'], minIntensity: 0.05, minSpacing: 0.5 },
    },
  ],
});
